<template>
<div :dir="$store.state.language == 'ar' ? 'rtl' : 'ltr'   ">
  <!-- Simple header with scrollable tabs. -->
  <div class="mdl-layout mdl-js-layout mdl-layout--fixed-header {{noDrawer}}">
    <heading v-if="forceReload"></heading>
    <main class="ga-content mdl-layout__content"  id="scroll-tab">
      <section>
        <router-view></router-view>
        <footing v-if="forceReload"></footing>
      </section>
      <div v-show="loading" class="loading" transition="fade">
        <div class="message">
          <div class="spinner">
            <div class="mdl-spinner mdl-js-spinner is-active"></div>
          </div>
          <div class="label">{{ 'general.app.loading.label' | label }}</div>
        </div>
      </div>
    </main>
  </div>

  <div v-show="error.show" v-if="forceReload" class="error" transition="fade">
    <div class="mdl-dialog">
      <h3 class="mdl-dialog__title">{{ 'general.app.error.title' | label}}</h3>
      <div class="mdl-dialog__content">
        <p>
          {{ error.message | label }}
        </p>
        <p v-if="!error.message">
          {{ 'general.app.error.message' | label}}
        </p>
      </div>
      <div class="mdl-dialog__actions">
        <div class="mdl-button mdl-js-button mdl-button--colored"
          v-on:click="$emit('dismis-error')">{{ 'general.app.dialog.close' | label}}</div>
      </div>
    </div>
  </div>

  <div v-show="alertMessage.show" style="z-index:98" v-if="forceReload" class="modal" transition="fade">
    <div class="mdl-dialog">
      <h3 class="mdl-dialog__title"></h3>
      <div class="mdl-dialog__content">
        {{ alertMessage.message  | label }}
      </div>
      <div class="mdl-dialog__actions">
        <div class="mdl-button mdl-js-button mdl-button--colored"
          v-on:click="$emit('dismiss-alert-message')">{{ 'general.app.dialog.close' | label}}</div>
      </div>
    </div>
  </div>

  <!-- <dialog v-show="false" id="error-dialog" class="mdl-dialog">
    <div class="mdl-dialog__content">
      <p>
        {{ error.message | label }}
      </p>
      <p>
        {{ 'general.app.error.message' | label}}
      </p>
    </div>
    <div class="mdl-dialog__actions">
      <div class="mdl-button mdl-js-button mdl-button--raised"
        v-on:click="$emit('dismis-error')">{{ 'general.app.dialog.close' | label}}</div>
    </div>
  </dialog> -->
  <div v-el:successresult class="mdl-js-snackbar mdl-snackbar ga-snackbar">
    <div class="mdl-snackbar__text"></div>
    <button class="mdl-snackbar__action" type="button"></button>
  </div>
</div>
</template>

<script>
var store = require('common/store')
var local = require('common/store/local')
var actions = require('common/store/actions')
var getters = require('common/store/getters')
var label = require('vue').filter('label')
var Vue = require('vue')

module.exports = {
  ready: function () {
    this.changeStyle()
    var auth = local.get('client.auth')
    if (auth) {
      var path = this.$route.path
      console.log(path.split('/app').length)
      if (!path || path.split('/app').length === 1) {
        path = '/app/message/new'
      }
      if (this.$route.query && this.$route.query.redirect) {
        path = this.$route.query.redirect
      }
      this.$emit('authenticate', auth, path)
    }

    this.drawer = document.getElementsByClassName('mdl-layout__drawer-button')[0]

    if (local.get('client.logged')) {
      this.noDrawer = ''
      if (this.drawer) this.drawer.classList.add('drawer-button')
      if (this.drawer) this.drawer.classList.remove('display-none')
    } else {
      if (this.drawer) this.drawer.classList.add('display-none')
      this.noDrawer = 'mdl-layout--no-drawer-button'
    }
    Vue.http.interceptors.push(this.authenticationInterceptor)
  },
  store: store,
  vuex: {
    getters: getters,
    actions: actions
  },
  components: {
    heading: require('./components/Heading'),
    footing: require('./components/Footer')
  },
  methods: {
    changeStyle: function () {
      if (this.$store.state.language === 'ar') document.querySelector('body').classList.toggle('rtl')
      else document.querySelector('body').classList.remove('rtl')
    },
    authenticationInterceptor: function (request, next) {
      var self = this
      next(function (response) {
        if (response.status === 401) {
          self.$emit('logout')
        }
      })
    }
  },
  data: function () {
    return {
      forceReload: true,
      loading: false,
      error: {
        show: false,
        message: ''
      },
      lang: '',
      noDrawer: '',
      drawer: '',
      alertMessage: {
        show: false,
        message: ''
      }
    }
  },
  watch: {
    '$store.state.language': function () {
      this.changeStyle()
      this.forceReload = false
      setTimeout(() => {
        this.forceReload = true
      }, 500)
    }
  },
  events: {
    'show-success': function (data) {
      this.$els.successresult.MaterialSnackbar.showSnackbar({
        message: label(data),
        timeout: 10000
      })
    },
    'dismis-error': function () {
      this.error.show = false
    },
    'show-error': function (data) {
      this.$emit('loading', false)
      this.error.show = true
      this.error.message = data.message
    },
    'show-alert-message': function (data) {
      let warn = local.get('client.warn.' + data)
      if (!warn) {
        this.alertMessage.show = true
        this.alertMessage.message = data
        local.put('client.warn.' + data, true)
      }
    },
    'dismiss-alert-message': function () {
      this.alertMessage.show = false
    },
    authenticate: function (authData, redirect) {
      var self = this
      this.login(authData, function (err, result) {
        if (err) {
          self.$emit('show-error', err)
        } else {
          self.noDrawer = ''
          if (self.drawer) self.drawer.classList.remove('display-none')
          if (self.drawer) self.drawer.classList.add('drawer-button')
          self.$emit('show-success', result)
          if (redirect) {
            self.$router.go(redirect)
          }
        }
      })
    },
    logout: function () {
      this.$emit('show-success', 'general.message.logout')
      this.logout()
      if (this.drawer) this.drawer.classList.add('display-none')
      this.noDrawer = 'mdl-layout--no-drawer-button'
      this.$router.go('/app/login')
    },
    'loading': function (spin) {
      this.loading = spin
    }
  }
}

</script>

<style scoped>
  main {
    display: flex;
    flex-direction: column;
  }
  section {
    flex: 1;
  }

  #scroll-tab {
    overflow-y: auto;
  }
  /* CHROME, FIREFOX, SAFARI AND OPERA */
  .mdl-menu{
  scrollbar-width: thin;
  scrollbar-color: #f19100 #E3E3E3;
  }
  .mdl-menu::-webkit-scrollbar{
    width: 5px;
    height: 5px;
    background-color: #E3E3E3;
  }
  .mdl-menu::-webkit-scrollbar-thumb{
    background-color: #F19100;
  }
</style>



// WEBPACK FOOTER //
// App.vue?8998edb0